import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtubation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.5 11V2M3 1.5L6 4.5M3 2.5L1 4.5",
		stroke: "black",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .3,
		d: "M9.5 2V11M9 11.5L12 8.5M10 11.5L7 8.5",
		stroke: "black",
		strokeWidth: 1.5
	})]
});
export default SvgExtubation;
